import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { StationAnprVM } from 'shell/view-models/station-anpr';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeOperator } from 'shell/models/typeoperator';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { AxiosResponse } from 'axios';
import { transformTypeOperator } from '../utils/transformer-type-operator';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
interface ListTypeOperatorProps {
  value: string;
  listOperators?: Array<ItemVM>;
  required?: boolean;
  disabledTypeOperator?: boolean;
  updateAnprVisibility?: (item?: boolean) => void;
  onChange: (item?: StationAnprVM) => void;
  errors?: boolean;
}

const MemoizedListOperators = ({
  onChange,
  disabledTypeOperator,
  updateAnprVisibility,
  required,
  value,
  errors,
}: ListTypeOperatorProps): React.ReactElement => {
  const [typeOp] = useHttpFetch<HttpResponseList<TypeOperator>, Array<StationAnprVM>>(
    `${__MANAGEMENT_API_URL__}/tipologia-operatore`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeOperator>>) =>
        transformTypeOperator(response),
    }
  );

  const typeOperators = (typeOp.data as Array<StationAnprVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={errors} id="type-operator-label">
        {required ? 'Tipologia operatore *' : 'Tipologia operatore'}
      </InputLabel>
      <PmiSelect
        labelId="type-operator-label"
        id="type-operator"
        name="type-operator"
        value={value}
        label={required ? 'Tipologia operatore *' : 'Tipologia operatore'}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(typeOperators.find((element) => element.id === selectedValue));
          if (updateAnprVisibility) {
            updateAnprVisibility();
          }
        }}
        disabled={disabledTypeOperator}
        error={errors}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {typeOperators
          ? typeOperators
              .sort((a, b) => a.value?.localeCompare(b.value))
              .map((typeoperator: ItemVM) => (
                <MenuItem key={typeoperator.id} value={typeoperator.id}>
                  {typeoperator.value}
                </MenuItem>
              ))
          : []}
      </PmiSelect>
    </PmiFormControl>
  );
};

MemoizedListOperators.displayName = 'List Type Operators component';

const ListTypeOperators = memo(MemoizedListOperators);

export default ListTypeOperators as typeof MemoizedListOperators;
